import { fromJS } from 'immutable';
import ACTIONS from '../app.constants';
import {
    ViolationReducerActionType,
    ViolationReducer,
    Violation,
    Comment,
    CommentList,
} from '../modules/application/types';
export default function violationReducer(
    state = fromJS({
        violationDetail: {},
        violationEditForm: {},
    }),
    action: ViolationReducerActionType,
): ViolationReducer {
    switch (action.type) {
        case ACTIONS.GET_VIOLATION_DETAIL_BY_ID.PENDING: {
            return state.setIn(['violationDetail', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.GET_VIOLATION_DETAIL_BY_ID.SUCCESS: {
            return state
                .setIn(['violationDetail', 'loading'], false)
                .setIn(['violationDetail', 'data'], action.data.violation)
                .setIn(['violationEditForm', 'data'], action.data.editForm);
        }
        case ACTIONS.GET_VIOLATION_DETAIL_BY_ID.ERROR: {
            return state.setIn(['violationDetail', 'loading'], false);
        }
        case ACTIONS.UPDATE_VIOLATION.PENDING: {
            return state.setIn(['violationData', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.UPDATE_VIOLATION.SUCCESS: {
            const violationData: Violation = state.getIn(['violationDetail', 'data']);
            return state.setIn(['violationData', 'loading'], false).setIn(['violationData', 'data'], violationData);
        }
        case ACTIONS.UPDATE_VIOLATION.ERROR: {
            return state.setIn(['violationData', 'loading'], false).setIn(['violationData', 'error'], action.error);
        }

        case ACTIONS.ADD_VIOLATION_COMMENT.PENDING: {
            return state.setIn(['violationComments', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.ADD_VIOLATION_COMMENT.SUCCESS: {
            const data = action.data;
            const comments: Comment[] = state.getIn(['violationComments', 'data']) ?? [];
            const newCommentData = comments.concat(data);
            return state
                .setIn(['violationComments', 'loading'], false)
                .setIn(['violationComments', 'data'], newCommentData);
        }
        case ACTIONS.ADD_VIOLATION_COMMENT.ERROR: {
            return state
                .setIn(['violationComments', 'loading'], false)
                .setIn(['violationComments', 'error'], action.error);
        }

        case ACTIONS.VIOLATION_COMMENT_LIST.PENDING: {
            return state.setIn(['violationComments', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.VIOLATION_COMMENT_LIST.SUCCESS: {
            let loadedList = state.getIn(['violationComments', 'data']) ?? [];
            const ViolationCommentList: CommentList = action.data as CommentList;
            const loadMore = ViolationCommentList.length < action?.paginationData?.limit ? false : true;
            if (loadedList && action?.paginationData?.skip > 0) {
                loadedList = loadedList.concat(ViolationCommentList);
            } else {
                loadedList = ViolationCommentList;
            }
            const violationCommentsList = state
                .setIn(['violationComments', 'loadMore'], loadMore)
                .setIn(['violationComments', 'data'], loadedList);
            return violationCommentsList;
        }
        case ACTIONS.VIOLATION_COMMENT_LIST.ERROR: {
            return state.setIn(['violationComments', 'loading'], false);
        }

        case ACTIONS.GET_OPENED_VIOLATIONS.PENDING: {
            return state.setIn(['openedViolations', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.GET_OPENED_VIOLATIONS.SUCCESS: {
            return state.setIn(['openedViolations', 'data'], action.data);
        }
        case ACTIONS.GET_OPENED_VIOLATIONS.ERROR: {
            return state.setIn(['openedViolations', 'loading'], false);
        }

        default: {
            return state;
        }
    }
}
